import Link from 'gatsby-link';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { MethodsService } from 'utils';
import { HeroImage, Media } from '..';
import TeaserImageComponent from '../caseList/subcomponents/image.component';
import TextWrapperComponent from '../caseList/subcomponents/textwrapper.component';

export const SmallCaseComponent = ({ name, teaserTitle, tags }) => (
    <SmallCaseWrapper>
        <CaseInfoComponent name={name} tags={tags} teaserTitle={teaserTitle} />
    </SmallCaseWrapper>
);

const SmallCaseWrapper = styled.div`
    border-top: 1px solid rgba(0, 0, 0, 0.14);
    padding-top: 1.7em;
    padding-bottom: 2.4em;
`;

const CaseInfoComponent = ({ name, teaserTitle, tags }) => (
    <CaseInfoWrapper>
        <div className="name">{name}</div>
        <div className="">{teaserTitle}
            {/* {tags
                .map(tag => tag.tag)
                .slice(0, 3)
                .join(' · ')} */}
        </div>
    </CaseInfoWrapper>
);

const CaseInfoWrapper = styled.div`
    .name {
        font-weight: 700;
        margin-bottom: 0.375em;
        // &:after {
        //     content: '→';
        //     float: right;
        // }
    }
`;

class CaseComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.delay = 0;
        this.state = {
            delay: 0,
        };

        this.caseCard = React.createRef();
    }

    navigateToCase(event, slug) {
        const { teaserImageWide } = this.props;
        event.preventDefault();
        MethodsService.getMethod('navigateWithTransition')(
            'toCase',
            <HeroImage image={teaserImageWide} />,
            this.caseCard.current.getBoundingClientRect(),
            `/${slug}`
        );
    }

    setDelay(delay) {
        this.setState({ delay: delay });
    }
    render() {
        const {
            teaserTitle,
            teaserImageWide,
            teaserImageTall,
            imageBackgroundColor,
            name,
            hover,
            slug,
            tags,
        } = this.props;

        let teaserImage;
        if (teaserImageTall != null) {
            teaserImage = teaserImageTall;
        } else if (teaserImageWide != null) {
            teaserImage = teaserImageWide;
        }
        return (
            <Link
                to={`/work/${slug}`}
                onClick={event => this.navigateToCase(event, `work/${slug}`)}
                css={LinkCSS}>
                <TeaserImageComponent
                    data-cursor="focus"
                    data-cursor-persistance="200"
                    width="100%"
                    maxWidth={1080}
                    maxHeight={720}
                    align="right"
                    ref={el => (this.refbox = el)}
                    className={hover ? 'hover' : ''}>
                    <TeaserImageWrapper ref={this.caseCard}>
                        {teaserImage && (
                            <Media
                                image={{
                                    ...teaserImage,
                                    sizes: {
                                        ...teaserImage.sizes,
                                        // aspectRatio: 16 / 9,
                                    },
                                }}
                                autoplay={true}
                                loop={true}
                                backgroundColor={
                                    imageBackgroundColor &&
                                    imageBackgroundColor.hex
                                }
                            />
                        )}
                    </TeaserImageWrapper>
                    <TextWrapperComponent
                        data-cursor="focus"
                        data-cursor-persistance="200"
                        css={TextWrapper}>
                        <CaseInfoComponent name={name} tags={tags} teaserTitle={teaserTitle} />
                    </TextWrapperComponent>
                </TeaserImageComponent>
            </Link>
        );
    }
}

const TeaserImageWrapper = styled.div`
    /* padding-bottom: 58%; */
    /* position: relative;
    overflow: hidden; */

    & > div {
        /* position: absolute !important; */
    }

    video {
        /* transform: scale(1.1); */
    }
`;

const LinkCSS = css`
    text-decoration: none;
`;

const TextWrapper = css`
    left: 0;
    position: relative;
    margin-top: 1em;
    margin-bottom: 2.2em;

    text-decoration: none;
`;
const title = css`
    white-space: normal;
    font-size: 72%;
`;
const client_css = css`
    
`;

export default CaseComponent;
